import {
  any,
  assoc,
  complement,
  dissoc,
  filter,
  find,
  has,
  isEmpty,
  isNil,
  map,
  mergeLeft,
  propOr,
  propSatisfies,
  reduce,
  unnest,
} from "ramda";

const findWith = (key, stipProperties) =>
  find(propSatisfies(complement(isNil), key), stipProperties);

export const getStipValue = (key, stipProperties) =>
  propOr("", key, findWith(key, stipProperties));

// Region names repeat across countries, so read both from the same submission
export const getStipRegion = stipProperties => {
  const entry = findWith("submissionRegion", stipProperties);
  return {
    region: propOr("", "submissionRegion", entry),
    country: propOr("", "submissionCountry", entry),
  };
};

// Matches the API, which applies each change to every submission
export const updateStipRows = (changes, stipProperties) =>
  map(mergeLeft(changes), stipProperties);

// STIP fields Admins and IAP Managers can edit. Other STIP fields (e.g. rejectionNote) must not be resent
// Region and country are picked together, so they're saved together
const FIELD_GROUPS = [
  ["localLibrary"],
  ["submissionLocality"],
  ["submissionRegion", "submissionCountry"],
];

// Send only the fields that changed. The API applies them to every STIP row
export const setStipProperties = initialStip => update => {
  if (!has("stipProperties", update)) {
    return update;
  }
  const valueOf = key => getStipValue(key, update.stipProperties);
  const isChanged = key => valueOf(key) !== getStipValue(key, initialStip);
  const changes = reduce(
    (values, key) => assoc(key, valueOf(key), values),
    {},
    unnest(filter(any(isChanged), FIELD_GROUPS)),
  );

  return isEmpty(changes)
    ? dissoc("stipProperties", update)
    : assoc("stipProperties", [changes], update);
};
